// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3sF1u","legacyBtn":"MutateMid_legacyBtn__NGcOz"};